import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../../../localization/useTranslation.ts";
import { put } from "../../../../common/api/apiShared.ts";
import { ExcludeAccessDialogProps } from "./ExcludeAccessDialog.tsx";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";

export function useExcludeAccessDialog(props: ExcludeAccessDialogProps) {
    const snackbar = useDotLegalSnackbar();

    const { translateString } = useTranslation();

    const excludeAccessMutation = useDotLegalMutation(excludeSystemAccessApi);
    const onExcludeAccess = () => {
        excludeAccessMutation.mutateAsync(undefined, {
            onSuccess: () => {
                snackbar.show(translateString("accessExcluded"));
                props.onAccessExcluded();
            },
        });
    };

    return {
        inProgress: excludeAccessMutation.isLoading,
        onExcludeAccess,
    };

    function excludeSystemAccessApi() {
        return put(`/system-user-access/${props.systemId}/exclude-access/${props.userId}`, null);
    }
}
